
<div class="main-card mb-3">
    <div class="user-details-container">
        <div class="user-card">
            <div class="header">
                <h2>User Details</h2>

                <!-- <div class="icon-right"><img  src="./assets/images/avatars/2.jpg" alt="" class="rounded-circle"></div> -->
                <div class="icon-right ">
                    <label for="profileUpload" style="cursor: pointer;">
                        <img [src]="profile_image" alt="Profile Image"
                            class="rounded-circle profile-img" />
                        <i class="fa fa-pencil edit-icon" aria-hidden="true"
                            title="Edit"></i>
                    </label>

                    <input type="file" id="profileUpload"
                        (change)="onImageSelected($event)" hidden />
                </div>

                <button class="close-btn" (click)="cancel()">✖</button>
            </div>
            <form id="l">
                <div class="grid" *ngFor="let v of userdetails">
                    <div class="form-group ">
                        <label for="userId" class="form-label"><span>User
                                Id</span></label>
                        <span class="user-cont">{{v.user_id}}</span>
                    </div>
                    <div class="form-group">
                        <label for="fname" class="form-label"><span>First
                                Name</span></label>
                        <span class="user-cont">{{v.first_name}}</span>
                    </div>
                    <div class="form-group">
                        <label for="lname" class="form-label"><span>Last
                                Name</span></label>
                        <span class="user-cont">{{v.last_name}}</span>
                    </div>
                    <div class="form-group">
                        <label for="exampleEmail11"
                            class="form-label"><span>Email</span></label>
                        <span class="user-cont">{{v.email}}</span>
                    </div>
                    <div class="form-group">
                        <label for="exampleAddress"
                            class="form-label"><span>Address</span></label>
                        <span class="user-cont"> {{addressOnly}}</span>
                    </div>
                    <div class="form-group">
                        <label for="exampleCity"
                            class="form-label"><span>City</span></label>
                        <span class="user-cont">{{city}}</span>
                    </div>
                    <div class="form-group">
                        <label for="exampleState"
                            class="form-label"><span>State</span></label>
                        <span class="user-cont">Tamilnadu</span>
                    </div>
                    <!-- <div class="form-group">
                            <label for="exampleZip" class="form-label"><span>Zip</span></label>
                            <span class="user-cont">{{v.user_id}}</span>
                        </div>
                        <div class="form-group">
                            <label for="mobileNumber" class="form-label"><span>Mobile Number</span></label>
                            <span class="user-cont">{{v.mobile}}</span>
                        </div> -->
                    <div class="form-group">
                        <label for="phoneNumber" class="form-label"><span>Phone
                                Number</span></label>
                        <span class="user-cont">{{v.phone}}</span>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>